var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13V0H21L13.3966 6.60444L21 13H0Z",
    fill: "#E04C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27344 8.82221V3.23389H7.6401V4.07128H5.26464V5.49827H7.27267V6.33566H5.26464V7.98481H7.72555V8.82221H4.27344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79439 8.82221V8.01899H10.0078V4.44725H9.00801V3.83202C9.27574 3.78076 9.5093 3.72094 9.70868 3.65258C9.90806 3.57853 10.0932 3.49023 10.2641 3.38769H10.999V8.01899H12.0671V8.82221H8.79439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1Icon);
export default __webpack_public_path__ + "static/media/E1-icon.ccae18c7f4dd082316871cc5c1471f6d.svg";
export { ForwardRef as ReactComponent };